import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ISalaryFileDetailsDataTableRowFormMeta {
  cdEntr: FormInputMeta,
  companyAccount: FormInputMeta,
  holderRegistrationNumber: FormInputMeta,
  operation: FormInputMeta,
  cardType: FormInputMeta,
  procDate: FormInputMeta,
  statusTable: FormInputMeta,
  
  schema: any,
}

const SalaryFileDetailsDataTableRowFormMeta = {} as ISalaryFileDetailsDataTableRowFormMeta;


SalaryFileDetailsDataTableRowFormMeta.cdEntr = {
  name: 'cdEntr',
  type: 'text',
  label: 'Cd. Entr',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.companyAccount = {
  name: 'companyAccount',
  type: 'text',
  label: 'Compte Societe',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.holderRegistrationNumber = {
  name: 'holderRegistrationNumber',
  type: 'text',
  label: 'Matricule porteur',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.operation = {
  name: 'operation',
  type: 'text',
  label: 'Operation',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.cardType = {
  name: 'cardType',
  type: 'select',
  label: 'Type Carte',
  options:  [
    {
      label: 'Type carte A',
      value: 'a'
    },
    {
      label: 'Type carte B',
      value: 'b',
    },
    {
      label: 'Type carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.statusTable = {
  name: 'statusTable',
  type: 'select',
  label: 'Statut',
  options:  [
    {
      label: 'Statut A',
      value: 'a'
    },
    {
      label: 'Statut B',
      value: 'b',
    },
    {
      label: 'Statut C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.procDate = {
  name: 'procDate',
  type: 'date',
  label: 'Date Proc.',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(SalaryFileDetailsDataTableRowFormMeta));

export default SalaryFileDetailsDataTableRowFormMeta;